import * as entity from '@common/domain/entities/RequisitionFileCabinet'
import * as app from '@framework/app';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { IDataEndPoint, IFieldOptions } from '../../../framework/interfaces/IEntity';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
import { ViewType, FieldType } from '../../../framework/core/Enums';
import { appSettings } from '@shared/components/appSettings';
import { AppSettings } from 'src/app/entities/AppSettings';
export class RequisitionFileCabinetEndPoints extends entity.RequisitionFileCabinetEndPoints {
  list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/perRequisition/" + serviceCommand.context.entityId }, method: "GET" };
  update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/updateWithFile/" + serviceCommand.context.entityId }, method: "POST" };
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      debugger;
      return app.config.controllerRouteRoot + "/requisitionFileCabinet/createWithFile/" + serviceCommand.context.parent.previousEntityId
    }, method: "POST"
  };
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/withFile/" + serviceCommand.context.entityId }, method: "GET" };
  search?: IDataEndPoint = null;
}

export class RequisitionFileCabinetFormFields extends entity.RequisitionFileCabinetFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length)
      let file: IFieldOptions = {
        field: "file", required: true, viewType: ViewType.File, fieldType: FieldType.String, name: "File", dataDisplayField: "fileName", dataIdField: "fileCabinetId",
        dataEndPoint: { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/download/", method: "POST" },
        insertEndPoint: { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/uploadNewFiles", method: "POST" },
      };
      let description: IFieldOptions = { field: "description", fieldType: FieldType.String, name: "Description" };
      description.viewType = ViewType.Text;
      this.push(file)
      this.push(description)
    } catch  { }
  }
}

export class RequisitionFileCabinetForm extends entity.RequisitionFileCabinetForm {
  protected requisitionFileCabinetFormEndPoints: RequisitionFileCabinetEndPoints = new RequisitionFileCabinetEndPoints();
  protected requisitionFileCabinetFormFields: RequisitionFileCabinetFormFields = new RequisitionFileCabinetFormFields();
}

export class RequisitionFileCabinetListColumns extends entity.RequisitionFileCabinetListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);

      this.push(FormBuilderControlListHelper.getListColumn("datestamp", "Datestamp", null, null, "datestamp"))
      this.push(FormBuilderControlListHelper.getListColumn("fileName", "Filename", null, null, "fileName"))
      this.push(FormBuilderControlListHelper.getListColumn("description", "Description", null, null, "description"))
    } catch  { }
  }
}

export class RequisitionFileCabinetList extends entity.RequisitionFileCabinetList {
  protected requisitionFileCabinetListEndPoints: RequisitionFileCabinetEndPoints = new RequisitionFileCabinetEndPoints();
  protected requisitionFileCabinetListColumns: RequisitionFileCabinetListColumns = new RequisitionFileCabinetListColumns();
}
